import styled from 'styled-components'

export const FilterBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  flex-grow: ${prop => (prop.dropdowns ? 1 : 0)};
  justify-content: 'flex-start';

  > div,
  > a {
    margin-left: ${prop => (prop.dropdowns ? 15 : 0)}px;
    margin-right: ${prop => (prop.dropdowns ? 20 : 0)}px;
  }

  &.select-week .select-field {
    width: 30px;
  }
`
